import "core-js/modules/es6.array.index-of";
var t = null,
    n = [];

function e(t) {
  for (var e = t.clientX, o = t.clientY, r = 0; r < n.length; r++) {
    n[r](e, o);
  }
}

export default function (o, r) {
  function i(t, n) {
    var e = o.getBoundingClientRect(),
        i = e.left,
        a = e.top,
        f = e.height,
        l = e.width;
    if (t > i && t < e.right && n > a && n < e.bottom) for (var u = function u(e) {
      var o = [].concat(r[e]),
          u = o[0],
          c = o[1];
      void 0 === c && (c = 0);
      var d = (t - (l / 2 + i)) * c,
          s = (n - (f / 2 + a)) * c;
      requestAnimationFrame(function () {
        u.style.transform = "translate3d(" + d + "px, " + s + "px, 0)";
      });
    }, c = 0; c < r.length; c++) {
      u(c);
    } else for (var d = 0; d < r.length; d++) {
      r[d][0].style.transform = "";
    }
  }

  return void 0 === o && (o = document.body), t || (t = document.addEventListener("mousemove", e)), n.push(i), function () {
    n.splice(n.indexOf(i), 1);
  };
}
;